import { Transform } from "class-transformer"

import { CsvTransform } from "../helpers/csvTransform.helper"

export class RawEraUploadCsvRowDTO {
    index?: number

    @Transform(({ value }) => CsvTransform.trim(value))
    patientFirstName?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    patientLastName?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    patientDateOfBirth?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    memberId?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    payerEntityName?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    nirvanaPayerId?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    isInsurancePrimary?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    providerNpi?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    claimId?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    appointmentDate?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    cptCode?: string

    @Transform(({ value }) => CsvTransform.toOptionalNumber(value))
    billAmount?: number

    @Transform(({ value }) => CsvTransform.trim(value))
    isInOffice?: string

    @Transform(({ value }) => CsvTransform.trim(value))
    isInNetwork?: string

    @Transform(({ value }) => CsvTransform.toOptionalNumber(value))
    insurancePaidAmount?: number

    @Transform(({ value }) => CsvTransform.toOptionalNumber(value))
    allowedAmount?: number

    @Transform(({ value }) => CsvTransform.toOptionalNumber(value))
    copaymentAmount?: number

    @Transform(({ value }) => CsvTransform.toOptionalNumber(value))
    coinsuranceAmount?: number

    @Transform(({ value }) => CsvTransform.toOptionalNumber(value))
    deductibleAmount?: number
}
